<template>

<app-content :loading="is.loading">

	<app-content-head title="Store" subtitle="Browse the available items and purchase more add-ons for your badge." />

	<app-content-body :is-grid="(collection.length) ? 4 : false">

		<app-card to-name="Convention.Registration.Store.Category" :no-actions="true" :to-id="item.id" v-for="item in collection" tooltip="Click to view category" :key="item.id" :image="item.image" :title="item.name" />
		
	</app-content-body>

</app-content>

</template>

<script>

export default {

	data: function() {

		return {
			is: {
				loading: true
			},
			collection: []
		}

	},

	created: function() {

		this.load()

	},

	methods: {

		load: function() {

			this.$api.get('convention/registration/store').then(function(json) {

				this.collection = json.collection

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>